// 相关的本地文本
export const textLocalConfig = [
  {
    id: "common_date",
    key: "date",
  },
  {
    id: "common_Zone",
    key: "zone",
  },
  {
    id: "common_Region",
    key: "region",
  },
  {
    id: "common_Country",
    key: "country",
  },
  {
    id: "common_System",
    key: "system",
  },
  {
    id: "common_Channel",
    key: "channel",
  },
  {
    id: "common_Language",
    key: "language",
  },

  {
    id: "common_Category",
    key: "category",
  },

  {
    id: "common_Product",
    key: "product",
  },
  {
    id: "common_Sum",
    key: "sum",
  },
  {
    id: "common_Max",
    key: "max",
  },
  {
    id: "common_Min",
    key: "min",
  },
  {
    id: "common_Average",
    key: "avg",
  },
  {
    id: "common_Count",
    key: "count"
  },
  {
    id: "common_Average(remove_Null)",
    key: "avg_no_null",
  },
  {
    id: "common_Average(remove_Null&0)",
    key: "avg_no_null_zero"
  },
  {
    id: "common_timezone",
    key: "timezone"
  },
]

export const pcConsoleRevenuePlafromFilterDefault = [
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  }
]
